/**
 * @param {string} svg
 * @param {HTMLElement} svgContainer
 */
export const getSvgMaskStyle = (maskImageSource) => ({
	maskImage: maskImageSource,
	maskSize: "100%",
	maskRepeat: "no-repeat",
	maskPosition: "center",
});

export const getSvgMaskStyleFromUrl = (maskImageUrlSource) => {
	const maskImageURL = `url(${maskImageUrlSource})`;
	return getSvgMaskStyle(maskImageURL);
};

export const addSVGDataMime = (encodedBase64) =>
	`data:image/svg+xml;base64,${encodedBase64}`;
